import { zip as observableZip } from "rxjs";

import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { ICompany, IResponseWithLoading, ISiteSlim } from "App/Modules/Models";
import type { ICompaniesRepository } from "App/Modules/Repositories";
import type { IModalService, IPageService } from "App/Modules/Services";
import { addLoading } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class CompanyDetailsComponentController implements IComponentController {
    public static $inject: string[] = [
        "$scope",
        "irPageService",
        "mmCompaniesRepository",
        "mmModalService",
        "$translate",
    ];

    public companyId: string;

    public company: IResponseWithLoading<ICompany>;

    public companySites: IResponseWithLoading<ISiteSlim[]>;

    public sitesSubCaption: string;

    constructor(
        private readonly $scope: IScope,
        private readonly pageService: IPageService,
        private readonly companiesRepository: ICompaniesRepository,
        private readonly modalService: IModalService,
        private readonly $translate: ng.translate.ITranslateService,
    ) {}

    public $onInit() {
        const sitesObservable = extendWithLoadingAndFail(
            this.companiesRepository.getSitesForCompany(this.companyId),
        ).pipe(addLoading(this.pageService));

        const companyObservable = extendWithLoadingAndFail(this.companiesRepository.getCompany(this.companyId)).pipe(
            addLoading(this.pageService),
        );

        observableZip(companyObservable, sitesObservable)
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                ([company, sites]) => {
                    this.company = company;
                    this.companySites = sites;
                    if (sites.data && !sites.isLoading) {
                        this.setSiteSubCaption(sites.data.length);
                    }
                },
                (error: IResponseWithLoading<null>) => {
                    this.company = error;
                },
            );
    }

    public editCompany() {
        this.modalService
            .open<ICompany, number>("irEditCompany", this.company.data, this.companySites.data.length)
            .subscribe(
                (editedCompany: ICompany) => {
                    this.company.data = editedCompany;
                },
                (error) => error,
            );
    }

    public setSiteSubCaption(numSites: number) {
        this.$translate("Entities.Site.NumSitesFormat", { numSites }, "messageformat").then((translation: string) => {
            this.sitesSubCaption = translation;
        });
    }
}
